import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import ArticleCard from '@/components/base/ArticleCard';

export default function FeaturedArticles() {
  const { t } = useTranslation();
  const featured = articles.slice(0, 6);

  return (
    <section id="featured" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            {t('home.featuredTitle')}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            精选优质内容，助你从容应对家庭关系中的每一个挑战
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((article) => {
            const cat = categories.find((c) => c.slug === article.category);
            return (
              <ArticleCard
                key={article.id}
                id={article.id}
                title={article.title}
                excerpt={article.excerpt}
                category={article.category}
                author={article.author}
                date={article.date}
                readTime={article.readTime}
                image={article.image}
                categoryName={cat?.name}
                categorySlug={cat?.slug}
              />
            );
          })}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/stepmother-relationship"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            {t('common.viewAll')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}